import React from 'react';
import { ContentPage, TermsOfServicePage } from '@front-activerse/modules';
import { Route } from '../Routing/types';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/privacy-policy',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/payment-info',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-android',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-ios',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/terms-of-service-web',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/how-to',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
  {
    path: '/info',
    element: <ContentPage />,
    private: false,
    title: dummy_t('content.navbarTitle'),
    mobileAppTabIdentifier: 'more',
  },
];

export default routes;
